export default __webpack_public_path__ + "static/media/institute-2-min.33f9f4a5.webp";